import { Injectable } from '@angular/core';
import { GridInput } from '@it2go/data-grid';
import { OkObject } from '@it2go/types';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { AttendanceCreateInput } from '@libs/types/src/services/input-type/attendance/attendance.create-input';
import { AttendanceObject, AttendanceObjectGrid } from '@libs/types/src/services/object-type/attendance/attendance.object';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { filterFrag } from './types/filter.types';
import { AttendancePatchInput } from '@libs/types/src/services/input-type/attendance/attendance.patch-input';
import { AttendanceWorksInput } from '@libs/types/src/services/input-type/attendance/attendance-works.input';
import { AttendanceWorkObject } from '@libs/types/src/services/object-type/attendance/attendance-work.object';

@Injectable({ providedIn: 'root' })
export class AttendanceGqlService extends GqlServiceV2 {

    public getAttendances(input: GridInput, fragment: string) {
        return this.query<AttendanceObjectGrid>(`
            query($input: GridInput!) {
                attendance {
                    filter(input: $input) {
                        ${filterFrag}
                        items {
                            ${fragment}
                        }
                    }
                }
            }
        `, { input });
    }

    public createAttendance(input: AttendanceCreateInput, fragment: string) {
        return this.mutate<AttendanceObject>(`
            mutation($input: AttendanceCreateInput!) {
                attendance {
                    create(input: $input) {
                        ${fragment}
                    }
                }
            }
        `, { input });
    }

    public patchAttendance(input: AttendancePatchInput, fragment: string) {
        return this.mutate<AttendanceObject>(`
            mutation($input: AttendancePatchInput!) {
                attendance {
                    patch(input: $input) {
                        ${fragment}
                    }
                }
            }
        `, { input });
    }

    public deleteAttendance(input: IdInput, fragment: string = 'ok') {
        return this.mutate<OkObject>(`
            mutation($input: IdInput!) {
                attendance {
                    delete(input: $input) {
                        ${fragment}
                    }
                }
            }
        `, { input });
    }

    public getAttendanceWorks(input: AttendanceWorksInput, fragment: string) {
        return this.query<AttendanceWorkObject[]>(`
            query($input: AttendanceWorksInput!) {
                attendance {
                    works(input: $input) {
                        ${fragment}
                    }
                }
            }
        `, { input });
    }

}
